import { baseGatewayApiV1 } from '@verantos-dev/app-state-base';
import { type ListResponse, type ObjectResponse } from '@verantos-dev/types-common';
import {
  type ProjectDetail,
  type CreateProjectWithDatasetData,
  type DeleteProjectData,
  type ProjectCRUDResponse,
  type UpdateProjectDatasetData,
} from '@verantos-dev/types-projects';

import { PROJECTS_BASE_PATH } from './constants';

export const projectApiSlice = baseGatewayApiV1
  .enhanceEndpoints({
    addTagTypes: ['projects'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProjects: builder.query<ListResponse<ProjectDetail>, string | null>({
        query: (urlParams: string) => {
          const params = urlParams ? `${encodeURI(urlParams)}` : '';
          return `/${PROJECTS_BASE_PATH}/${params}`;
        },
        providesTags: ['projects'],
      }),

      getProject: builder.query<ObjectResponse<ProjectDetail>, string>({
        query: (id: string) => `/${PROJECTS_BASE_PATH}/${id}`,
        providesTags: ['projects'],
      }),

      createProject: builder.mutation<ProjectCRUDResponse, CreateProjectWithDatasetData>({
        query: (data) => ({
          url: `/${PROJECTS_BASE_PATH}/`,
          method: 'POST',
          body: { ...data },
        }),
        invalidatesTags: ['projects'],
      }),

      /** Switch the project's active dataset — the default new cohorts and
       *  analytical datasets are created against. Existing ones keep the
       *  dataset they were built on. */
      updateProjectDataset: builder.mutation<
        ObjectResponse<ProjectDetail>,
        UpdateProjectDatasetData
      >({
        query: ({ projectId, datasetReleaseId, datasetReleaseName }) => ({
          url: `/${PROJECTS_BASE_PATH}/${projectId}`,
          method: 'PATCH',
          body: { datasetReleaseId, datasetReleaseName },
        }),
        invalidatesTags: ['projects'],
      }),

      deleteProject: builder.mutation<ProjectCRUDResponse, DeleteProjectData>({
        query: ({ projectId }) => ({
          url: `/${PROJECTS_BASE_PATH}/${projectId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['projects'],
      }),
    }),
  });
export const {
  useGetProjectsQuery,
  useGetProjectQuery,
  useCreateProjectMutation,
  useUpdateProjectDatasetMutation,
  useDeleteProjectMutation,
} = projectApiSlice;
